/*
 * Decoration options are their own cart lines. Variant titles look like
 * "Fringe / One Size" (option + Size), while cart.js variant_options is
 * ["Fringe", "One Size"]. Those two are not equal, so quantity updates
 * never included the decoration line and it could not be removed.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.HamiltonCart = api;
})(typeof window !== 'undefined' ? window : global, function () {
  function normalizeText(value) {
    return String(value == null ? '' : value)
      .replace(/&amp;/g, '&')
      .replace(/&#39;|&apos;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function propertyValue(props, name) {
    if (!props) return '';
    var target = String(name).toLowerCase();
    for (var key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key) && String(key).toLowerCase() === target) {
        return props[key];
      }
    }
    return '';
  }

  function copyProps(props) {
    var next = {};
    if (!props) return next;
    for (var key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key)) next[key] = props[key];
    }
    return next;
  }

  function decorationNamesFromProperty(value) {
    return String(value || '')
      .split(',')
      .map(function (part) {
        return normalizeText(String(part).split('+')[0]);
      })
      .filter(function (name) {
        return name.length > 0;
      });
  }

  function variantOptionLabel(item) {
    if (!item) return '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return normalizeText(item.variant_title);
    }
    if (Object.prototype.toString.call(item.variant_options) === '[object Array]') {
      return normalizeText(item.variant_options.join(' / '));
    }
    return normalizeText(item.variant_options);
  }

  function sameText(a, b) {
    return normalizeText(a).toLowerCase() === normalizeText(b).toLowerCase();
  }

  function colorsCompatible(a, b) {
    a = normalizeText(a).toLowerCase();
    b = normalizeText(b).toLowerCase();
    if (!a || !b) return true;
    return a === b;
  }

  function decorationMatchesSelection(item, selectedNames) {
    if (!selectedNames || !selectedNames.length || !item) return false;
    var candidates = [variantOptionLabel(item)].concat(
      decorationNamesFromProperty(propertyValue(item.properties, 'Decoration_option'))
    );
    if (Object.prototype.toString.call(item.variant_options) === '[object Array]' && item.variant_options.length) {
      candidates.push(normalizeText(item.variant_options[0]));
    }
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i]) continue;
      for (var j = 0; j < selectedNames.length; j++) {
        if (sameText(candidates[i], selectedNames[j])) return true;
      }
    }
    return false;
  }

  function propertiesWithoutDecoration(props, variantLabel) {
    var next = copyProps(props);
    var keyName = null;
    for (var key in next) {
      if (Object.prototype.hasOwnProperty.call(next, key) && String(key).toLowerCase() === 'decoration_option') {
        keyName = key;
      }
    }
    if (!keyName) return next;
    var kept = [];
    var parts = String(next[keyName] || '').split(',');
    for (var i = 0; i < parts.length; i++) {
      var name = normalizeText(String(parts[i]).split('+')[0]);
      if (!name || sameText(name, variantLabel) || sameText(name, normalizeText(String(variantLabel).split('/')[0]))) continue;
      kept.push(normalizeText(parts[i]));
    }
    if (kept.length) next[keyName] = kept.join(', ');
    else delete next[keyName];
    return next;
  }

  function findUpdate(updates, id) {
    for (var i = 0; i < updates.length; i++) {
      if (updates[i].id == id) return updates[i];
    }
    return null;
  }

  function queueUpdate(updates, id, quantity, properties) {
    var existing = findUpdate(updates, id);
    if (!existing) {
      existing = { id: id };
      updates.push(existing);
    }
    existing.quantity = quantity;
    if (properties) existing.properties = properties;
    else delete existing.properties;
    return updates;
  }

  function queuedQuantity(updates, id) {
    var existing = findUpdate(updates, id);
    if (!existing || existing.quantity == null || existing.quantity === '') return null;
    return parseInt(existing.quantity, 10);
  }

  function garmentName(item) {
    return normalizeText(propertyValue(item && item.properties, 'product') || (item && item.product_title) || '');
  }

  function clearDecorationFromRemainingGarments(cart, updates, productName, color, label) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var garment = items[i];
      if (!garment || garment.handle === 'decoration-options' || garment.handle === 'custom-color-set-up') continue;
      if (queuedQuantity(updates, garment.key) === 0) continue;
      if (!sameText(garmentName(garment), productName)) continue;
      if (!colorsCompatible(propertyValue(garment.properties, 'color'), color)) continue;

      var baseProps = (findUpdate(updates, garment.key) || {}).properties || garment.properties;
      if (!propertyValue(baseProps, 'Decoration_option')) continue;

      var nextProps = propertiesWithoutDecoration(baseProps, label);
      if (propertyValue(nextProps, 'Decoration_option') === propertyValue(baseProps, 'Decoration_option')) continue;

      var qty = queuedQuantity(updates, garment.key);
      if (qty == null) qty = garment.quantity;
      queueUpdate(updates, garment.key, qty, nextProps);
    }
    return updates;
  }

  function linkedDecorations(cart, garment) {
    var names = decorationNamesFromProperty(propertyValue(garment.properties, 'Decoration_option'));
    var productName = garmentName(garment);
    var color = propertyValue(garment.properties, 'color');
    var matches = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item || item.handle !== 'decoration-options') continue;
      if (!sameText(propertyValue(item.properties, 'product'), productName)) continue;
      if (!colorsCompatible(propertyValue(item.properties, 'color'), color)) continue;
      if (!decorationMatchesSelection(item, names)) continue;
      matches.push(item);
    }
    return matches;
  }

  function removalUpdates(cart, line) {
    var updates = [];
    if (!line) return updates;

    if (line.handle === 'decoration-options') {
      queueUpdate(updates, line.key, 0, null);
      clearDecorationFromRemainingGarments(
        cart,
        updates,
        propertyValue(line.properties, 'product'),
        propertyValue(line.properties, 'color'),
        variantOptionLabel(line)
      );
      return updates;
    }

    queueUpdate(updates, line.key, 0, null);
    var decorations = linkedDecorations(cart, line);
    for (var i = 0; i < decorations.length; i++) {
      var deco = decorations[i];
      var nextQty = (parseInt(deco.quantity, 10) || 0) - (parseInt(line.quantity, 10) || 0);
      if (nextQty < 0) nextQty = 0;
      if (nextQty === 0) {
        queueUpdate(updates, deco.key, 0, null);
        clearDecorationFromRemainingGarments(
          cart,
          updates,
          garmentName(line),
          propertyValue(line.properties, 'color'),
          variantOptionLabel(deco)
        );
      } else {
        queueUpdate(updates, deco.key, nextQty, copyProps(deco.properties));
      }
    }
    return updates;
  }

  return {
    normalizeText: normalizeText,
    propertyValue: propertyValue,
    decorationNamesFromProperty: decorationNamesFromProperty,
    variantOptionLabel: variantOptionLabel,
    sameText: sameText,
    colorsCompatible: colorsCompatible,
    decorationMatchesSelection: decorationMatchesSelection,
    propertiesWithoutDecoration: propertiesWithoutDecoration,
    queueUpdate: queueUpdate,
    clearDecorationFromRemainingGarments: clearDecorationFromRemainingGarments,
    linkedDecorations: linkedDecorations,
    removalUpdates: removalUpdates
  };
});
